<template>
    <div class="bckdiv xyz">
      <v-container fluid fill-height>
          <v-layout align-center justify-center style="margin-top:90px">
              <v-flex xs12 md8>
                  <v-card flat class="elevation-5">
                      <h2 style="text-align:center;padding-top:20px;color:#e91e63">Payment Security</h2>
                      <div style="border:2px solid;border-radius:5px;margin:30px;border-color:grey"><br/>
                      <p style="text-align:center">
                          Transactions made by <span style="color:#2196f3">https://www.aimroindiaa.com</span>, ensures that every transaction you conduct online is in a safe and secure environment. Aimro.com is protected by Secured Socket Layer (SSL) technology. 
                          Trust is the cornerstone of SSL protocol and that means we adhere to strict validation guidelines.

                      </p>
                      <p style="text-align:center">
                          In addition to the HTTPS and lock icon, our SSLs also include McAfee SECURE. Clean websites can display the McAfee trustmark on every page to reassure visitors that your payment is safe.
                      </p>
                      <p style="text-align:center">
                          Our SSLs use SHA-2 and 2048-bit encryption to protect all sensitive data transmitting from the browser to the web server. It’s the strongest encryption on the market today and it is virtually uncrackable.
                      </p>
                      <br/>
                      </div>
                  </v-card>
              </v-flex>

              <!-- <v-flex md8 sm8 xs12 style="text-align:center;padding-top: 200px;padding-right: 20px">
                  <div class="opct">
                      <v-icon color="#ff336d" size="50">help_outline</v-icon>
                      <h2 class="white--text">How can I help you?</h2>
                      <h3 class="white--text">Call Us</h3>
                      <p class="white--text contact_tag">+91 6290398678</p>
                      <h3 class="white--text">or Email Us</h3>
                      <p class="white--text contact_tag">info@aimroindia.com</p>
                  </div>
              </v-flex>

              <v-flex md4 sm4 xs12 class="help" style="padding-top: 70px;padding-right: 20px">
                  <v-container>
                      <v-card class="elevation-5 opct">
                          <h2 style="text-align:center;padding-top:20px;" class="enquiry">Drop us a line</h2>
                          <p style="text-align:center; color:#ff336d" class="contact_tag">We’d love to hear from you</p>
                            <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12 md2 sm2></v-flex>
                         <v-flex xs12 md8 sm8>
                           <v-text-field v-model="form1.name" label="Name"></v-text-field>

                           <v-text-field v-model="form1.name" label="Email"></v-text-field>

                           <v-text-field type="Number" v-model="form1.name" label="Phone number"></v-text-field>

                           <v-textarea v-model="form1.comment" label="Comment" ></v-textarea>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>

                         <br>

                         <v-flex xs12 md2 sm2></v-flex>
                         <v-flex xs12 md8 sm8>
                           <v-btn style="margin-bottom:30px" color="#ff336d" class="white--text" large block depressed @click="enquiry()">Submit</v-btn>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>
          
                       </v-layout>
                     </v-form>
                      </v-card>
                   </v-container>
                             </v-flex> -->
                         </v-layout>
                         
              </v-container>
    </div>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
    };
  },
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.bckdiv {
    background-image: url("../../assets/contact.jpg");
    background-size: cover;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .xyz {
      height: 625px;
  }
}
</style>
